/* eslint-disable */
export function castDirectionToBool(direction) {
  if (direction === 'desc' || direction === true) return true;
  if (direction === 'asc' || direction === false) return false;
  return undefined;
}
